import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Collapse, CollapseProps, Form, Input, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import ActivitiesView from 'app/entities/activities/view/activitiesView';
import KR from 'app/entities/kr/view/kr';
import { Container } from 'reactstrap';
import { getInfo } from '../objective.reducer';
import ObjectiveUpdate from './objective-update';

export const ObjectiveView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = useParams();
  const isNew = id === undefined;
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);

  const objectiveEntity = useAppSelector(state => state.objective.entity);

  useEffect(() => {
    if (objectiveEntity && !isNew) {
      form.setFieldsValue(objectiveEntity);
    }
  }, [objectiveEntity]);

  const handleClose = () => {
    navigate('/objective');
  };

  useEffect(() => {
    innitData();
  }, []);

  const innitData = () => {
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getInfo(id));
    }
  };

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: 'Thông tin mục tiêu',
      children: (
        <Row>
          <Col md={5}>
            <Form.Item label="Mã mục tiêu" name={'code'}>
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Lĩnh vực" name={'fieldName'}>
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Dự án" name={'name'}>
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Mảng công việc" name={'workTypeName'}>
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={24}>
            <Form.Item label="Nội dung mục tiêu" name={'purpose'}>
              <TextArea disabled placeholder="Nhập nội dung mục tiêu" size="large" />
            </Form.Item>
          </Col>
          <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
            {`Xem chi tiết mục tiêu >`}
          </span>
        </Row>
      ),
    },
    {
      key: '2',
      label: 'Danh sách KR',
      children: <KR />,
    },
    {
      key: '3',
      label: 'Danh sách công việc',
      children: <ActivitiesView />,
    },
  ];

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = (isReload = false) => {
    setIsOpenModalFormObjective(false);
  };

  return (
    <Container className="form">
      <Form size="large" form={form} layout="vertical">
        <Form.Item>
          <Collapse defaultActiveKey={'2'} items={items} />
        </Form.Item>
        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Đóng
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
      {isOpenModalFormObjective && <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={id} onClose={handleCloseModelObjective} />}
    </Container>
  );
};

export default ObjectiveView;
